export default __webpack_public_path__ + "static/media/calendar.b4ca57dd.svg";